/**
 * TanStack Query hooks for `published-sub-processor-list`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publishedSubProcessorListQueryKeys,
	type CreatePublishedSubProcessorListBody,
	type ListPublishedSubProcessorListResponse,
	type PublishedSubProcessorListRow,
} from "./api";

export function usePublishedSubProcessorListList(): UseQueryResult<ListPublishedSubProcessorListResponse, Error> {
	return useQuery({
		queryKey: publishedSubProcessorListQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublishedSubProcessorListCreate(): UseMutationResult<PublishedSubProcessorListRow, Error, CreatePublishedSubProcessorListBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publishedSubProcessorListQueryKeys.all });
		},
	});
}

export function usePublishedSubProcessorListDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publishedSubProcessorListQueryKeys.all });
		},
	});
}
